import { partnerVenueIsUnpinned } from './partnerHasFixedVenue';

/**
 * Whether a partner offering travels to the customer ("Aanbieder komt naar mij").
 *
 * An activity set at "a fixed location that is not yours" with no address on file counts as
 * travelling: there is no venue to go to, so for the visitor it happens wherever it is
 * agreed — a location of their choice. Routing it to the fixed tab instead left the page with
 * a venue tab pointing nowhere and no regions on the map.
 *
 * The activity's own `hasCustomLocations` flag is the authority — it is what the partner
 * configured and what the cart/checkout read (`checkout/(steps)/info/client.tsx`). Transport
 * pricing is only a fallback for legacy rows where the flag was never set: tiers exist on
 * plenty of activities that do not actually travel, which is what made the widget offer the
 * custom mode (and hide the venue) for fixed-only activities.
 */
export function partnerComesToYou(partner: {
    transportMultiplier?: number | null;
    transportCostTiers?: ReadonlyArray<unknown> | null;
    hasCustomLocations?: boolean | null;
    addresses?: ReadonlyArray<unknown> | null;
    hasOwnLocations?: boolean | null;
    hasFixedLocations?: boolean | null;
}): boolean {
    if (partnerVenueIsUnpinned(partner)) return true;
    if (partner.hasCustomLocations != null) return partner.hasCustomLocations;
    return (partner.transportMultiplier ?? 0) > 0 || !!partner.transportCostTiers?.length;
}
